import React, { useState } from 'react'
import { Box, Flex, Group, Center, SegmentedControl, Text, Button, Menu, Modal, Grid, Card, Image } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { useDisclosure } from '@mantine/hooks'
import { IconList, IconTable, IconPlus, IconDots } from '@tabler/icons-react'
import OrderProductList from './LayoutHelper/OrderProductList'
import OrderProductTable from './LayoutHelper/OrderProductTable'
import ImgCatalogList from '../../../../assets/img/images/product-lists.png'
import ImgFormLayout from '../../../../assets/img/images/form-layouts.png'
import ImgTables from '../../../../assets/img/images/tables.png'
import { useNavigate, useParams } from 'react-router-dom'
import FormAddProductUpload from './Form/FormAddProductUpload'
import { modalDeleteData } from '../../../ui/Prompt/modalDeleteData'
import { loadingNotification, completedLoadingNotification } from '../../../ui/Notifications'
import { getOrderDetail } from '../../../../store/orderDetail'
import { getOrderItems } from '../../../../store/orderItems'
import { calculation } from '../../../../services/calculation'
import { deleteAllItemsOrder } from '../../../../services/orders'

const defaultDataAddProduct = [
  {
    title: 'Add Form Catalog',
    caption: 'Add products from the asiacommerce catalog with up to 60,000 products.',
    image: ImgCatalogList,
    route: 'catalog'
  },
  {
    title: 'Add Manually',
    caption: 'Add product manually to order with manual input.',
    image: ImgFormLayout,
    route: 'form'
  },
  {
    title: 'Bulk Upload from Excel',
    caption: 'Add bulk product from excel.',
    image: ImgTables,
    route: 'modal'
  },
]


const defaultDataLayout = [
  { 
    label: (
      <Center style={{ gap: 10 }}>
        <IconList size={16} />
        <span>Card</span>
      </Center>
    ), 
    value: 'card' 
  },
  { 
    label: (
      <Center style={{ gap: 10 }}>
        <IconTable size={16} />
        <span>Table</span>
      </Center>
    ),
    value: 'table' 
  },
]

const OrderProductItems = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const orderId = params.order_id
  const { isLoadingOrderItems, dataOrderItems } = useSelector(state => state.order_items)
  const { summary } = useSelector(state => state.order_detail)
  const [selectedLayout, setSelectedLayout] = useState('card')
  const [openedModalAddProduct, { open, close }] = useDisclosure(false)
  const [openModalFormItemsUpload, setOpenModalFormItemsUpload] = useState(false)

  const onCloseFormItemsUpload = () => {
    setOpenModalFormItemsUpload(false)
  }

  const handleSelectAllBulk = () => {
    setSelectedLayout('table')
  }

  const handleReloadDataDetail = async () => {
    const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
    const responseCalculation = await calculation(orderId)
    if (responseCalculation.success) {
      dispatch(getOrderDetail(orderId))
      dispatch(getOrderItems(orderId))
      completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
    }
  }

  const handleDeleteAllProductItems = () => {
    modalDeleteData('All Product', orderId, 'All Product Items', deleteAllItemsOrder, handleReloadDataDetail)
  }

  const mappingSelectAddProduct = (dataMenu) => {

    const handleNavigate = (route) => {
      if (route === 'catalog') {
        navigate(`/order/${orderId}/add-product/catalog${summary ? `/${summary.orderCurrency}` : ''}`)
      } else if (route === 'modal') {
        setOpenModalFormItemsUpload(true)
      } else if (route === 'form') {
        navigate(`/order/${orderId}/add-product/manual`)
      }
    }
    
    const remapSelected = dataMenu.map((val, index) => {
      return (
        <Grid.Col span={4} key={index}>
          <Card shadow="md" padding='lg' radius='md' withBorder style={{ cursor: 'pointer' }} onClick={() => handleNavigate(val.route)}>
            <Card.Section>
              <Image src={val.image} height={160} fit='cover' />
            </Card.Section>
            <Box my={10} h={50}>
              <Text fz={14} fw={600} mb={6}>{val.title}</Text>
              <Text fz={11} fw={500} c='dimmed'>{val.caption}</Text>
            </Box>
          </Card>
        </Grid.Col>
      )
    })
    return remapSelected
  } 
  
  if (!isLoadingOrderItems) {
    return (
      <Box>
        <Box my={10}>
          <Box>
            <Flex justify='space-between' align='center' my={20}>
              <Group align='center'>
                <Box>
                  <SegmentedControl
                    withItemsBorders={false}
                    value={selectedLayout}
                    onChange={setSelectedLayout}
                    data={defaultDataLayout}
                    size='sm'
                    radius='sm'
                    color='red'
                  />
                </Box>
                <Text fz={16} fw='600'>{dataOrderItems.length} Products</Text>
              </Group>
              <Group align='center'>
                <Button size='xs' radius='sm' leftSection={<IconPlus size={14} />} onClick={open}>Add Product</Button>
                <Menu width={180} position="bottom-end" withArrow arrowPosition="center">
                  <Menu.Target>
                    <Button size="xs" radius='sm' variant='outline'><IconDots size={16} /></Button>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      fw='600'
                      fz={11}
                      disabled
                    >
                      Change Status
                    </Menu.Item>
                    <Menu.Item
                      fw='600'
                      fz={11}
                      disabled
                    >
                      Show Filter
                    </Menu.Item>
                    <Menu.Item
                      fw='600'
                      fz={11}
                      onClick={() => handleSelectAllBulk()}
                      disabled={dataOrderItems.length === 0}
                    >
                      Bulk Edit SKU Status
                    </Menu.Item>
                    <Menu.Item
                      fw='600'
                      fz={11}
                      color='red'
                      onClick={() => handleDeleteAllProductItems()}
                      disabled={dataOrderItems.length === 0}
                    >
                      Delete All Product
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Group>
            </Flex>
          </Box>
          <Box my={30}>
            {selectedLayout === 'card' ? <OrderProductList /> : <OrderProductTable />}
          </Box>
        </Box>
        <Modal opened={openedModalAddProduct} onClose={close} size="70%" withCloseButton={false} centered>
          <Box p={12}>
            <Grid align='center'>
              {mappingSelectAddProduct(defaultDataAddProduct)}
            </Grid>
          </Box>
        </Modal>
        <Modal opened={openModalFormItemsUpload} onClose={onCloseFormItemsUpload} centered size='85%' title={<Text fw='Bold'>Bulk Upload Product from Excel (.xlsx)</Text>} closeOnClickOutside={false} withCloseButton={false}>
          <FormAddProductUpload onCloseModal={onCloseFormItemsUpload} onCloseModalAdd={close} />
        </Modal>
      </Box>
    )
  }
  
}

export default OrderProductItems